
import ClickableCard from '@/components/ClickableCard.vue';
import DataTableComponent from '@/components/DataTableComponent.vue';
import { adminStore, toolStore, userToolStore } from '@/store';
import _ from 'lodash';
import { Component, Vue, Watch } from 'vue-property-decorator';

@Component({
  components: {
    DataTableComponent,
    ClickableCard,
  },
})
export default class MassPermission extends Vue {
  @Watch('selectAll')
  onChangeSelectAll(selectAll) {
    if (selectAll) {
      this.selectedTool = _.map(this.tools, 'id');
    } else {
      this.selectedTool = [];
    }
  }



  public selectedFranchisingKNN: any = [];
  public selectedFranchisingPHENOM: any = [];

  get selectedFranchising() {
    return [...this.selectedFranchisingKNN, ...this.selectedFranchisingPHENOM];
  }

  public selectAll = false;

  public removeRemanescent = false;
  public isLoading = false;
  public selectedType: any = [];
  public selectedTool: number[] | null = null;
  public selectedPermission: string[] | null = null;
  public selectedUsers: any[] | null = [];
  public addedPermissions: object[] = [];
  public currentStep = 1;

  public permissions = [
    { name: 'Visualizar', value: 'allow_view' },
    { name: 'Criar', value: 'allow_create' },
    { name: 'Editar', value: 'allow_edit' },
    { name: 'Deletar', value: 'allow_delete' },
  ];

  public headersTools = [
    {
      text: 'Módulo',
      sortable: true,
      value: 'tool_name',
      align: 'left',
      disabled: false,
    },
    {
      text: 'Visualizar',
      sortable: true,
      value: 'allow_view',
      align: 'left',
    },
    {
      text: 'Editar',
      sortable: true,
      value: 'allow_edit',
      align: 'left',
    },
    {
      text: 'Deletar',
      sortable: true,
      value: 'allow_delete',
      align: 'left',
    },
    {
      text: 'Adicionar',
      sortable: true,
      value: 'allow_create',
      align: 'left',
    },
  ];

  public headersToolsPermission = [
    ...this.headersTools,
    {
      text: 'Ações',
      sortable: true,
      value: 'remove',
      align: 'left',
      width: 50,
    },
  ];

  public headersUsers = [
    {
      text: 'Nome',
      sortable: true,
      value: 'full_name',
      align: 'left',
      type: 'varchar',
    },
    {
      text: 'Unidade',
      sortable: true,
      value: 'company_nome_fantasia',
      align: 'left',
      type: 'varchar',
    },
    {
      text: 'Departamento',
      sortable: true,
      value: 'departure_name',
      align: 'left',
      type: 'varchar',
      width: '13%',
    },
    {
      text: 'Cargo',
      sortable: true,
      value: 'role_name',
      align: 'left',
      type: 'autocomplete',
      width: '25%',
    },
  ];

  public tipoUnidadeItems = [
    {
      id: 0,
      name: 'Escola',
      description: 'Permissão para os usuários das unidades',
    },         
    {
      id: 1,
      name: 'Franchising',
      description: 'Permissão para os usuários da franchising',
    },
  ];

  get isMobile() {
    return this.$vuetify.breakpoint.mobile;
  }

  get sortedAddedPermissions() {
    return _.orderBy(this.addedPermissions, 'tool_name');
  }

  get tools() {
    return _.filter(
      toolStore.tools,
      (t: any) =>
        !_.some(this.addedPermissions, ['tool_id', t.id]) &&
        ((t.franchisee_tool && this.selectedType[1].id === 0) || (t.franchisor_tool && this.selectedType[1].id === 1))
    );
  }

  get users() {
    return adminStore.users;
  }

  public clearType() {
    this.selectedType = [];
    this.currentStep--;
  }

  public clearPermission() {
    this.addedPermissions = [];
    this.currentStep--;
  }

  public clearUser() {
    this.selectedUsers = [];
    this.currentStep--;
  }

  public addPermission() {
    _.forEach(this.selectedTool, (st) => {
      const permission = {
        tool_id: st,
        tool_name: _.find(this.tools, { id: st! })!['name'],
      };

      _.forEach(_.map(this.permissions, 'value'), (sp) => {
        permission[sp] = _.includes(this.selectedPermission, sp);
      });

      this.addedPermissions.push(permission);
    });

    this.selectedTool = null;
    this.selectedPermission = null;
  }

  // public editPermission(item: any) {
  //   this.isLoading = true;
  //   this.addedPermissions = _.without(this.addedPermissions, item);
  //   this.selectedTool = item.tool_id;
  //   this.selectedPermission = _.filter(_.keys(item), (k) => !_.includes(k, "tool"));
  //   this.isLoading = false;
  // }

  public deletePermission(item: any) {
    this.isLoading = true;
    this.addedPermissions = _.without(this.addedPermissions, item);
    this.isLoading = false;
  }

  public async onSubmit() {
    this.$swal({
      title: 'Aplicando permissões',
      icon: 'success',
      text: 'O processo pode demorar vários minutos, mas é possível sair desta tela enquanto aguarda.',
    });
    this.isLoading = true;

    const payload = {
      tools: this.addedPermissions,
      users_id: _.map(this.selectedUsers, 'id'),
      remove_remanescent: this.removeRemanescent,
    };

    await userToolStore.massPermissionPost(payload);
    this.$router.back();
    this.isLoading = false;
  }

  async loadUsers() {
    this.currentStep++;
    const searchParams = {
      is_active: true,
      is_franchise: this.selectedType[1].id === 0,
    };

    if (this.selectedFranchising.length === 1) {
      searchParams['idFranchising'] = _.includes(this.selectedFranchising, 'KNN BRASIL') ? 1 : 1069;
    }
    this.isLoading = true;
    await adminStore.getUsersBasic(searchParams);    
    this.isLoading = false;
  }

  public async mounted() {
    this.isLoading = true;
    await toolStore.getTools();
    this.isLoading = false;
  }

  public handleUserSelection(items: any[]) {
    this.selectedUsers = items;
  }
}
